import { render, staticRenderFns } from "./ConfigSelectuserForm.vue?vue&type=template&id=13445898&scoped=true"
import script from "./ConfigSelectuserForm.vue?vue&type=script&lang=js"
export * from "./ConfigSelectuserForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigSelectuserForm.vue?vue&type=style&index=0&id=13445898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13445898",
  null
  
)

export default component.exports